import { Box, Button, DialogActions, Modal, Stack, Typography } from '@mui/material'
import type React from 'react'
import { useContext, useState } from 'react'
import { LanguageContext } from '../util/LanguageContext'

type ModalDelDialogProps = {
  open: boolean
  title: string
  id?: string
  text?: string
  onClose: () => void
  onDel: (value: string) => void
}

export const ModalDelDialog: React.FC<ModalDelDialogProps> = props => {
  const { open, title, id, text, onClose, onDel } = props
  const [isOpen, setIsOpen] = useState(open)
  // 文字列変換用
  const translation = useContext(LanguageContext)

  const handleDel = () => {
    onDel(id!)

    onClose()
  }
  const truncate = (text: string, length = 13): string => {
    return text.length > length ? text.slice(0, length) + '...' : text
  }
  const handleClose = (event: React.MouseEvent<HTMLInputElement>, reason: 'backdropClick') => {
    if (reason === 'backdropClick') return
    onClose()
    setIsOpen(false)
  }
  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '300px',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: '388px',
          width: '640px',
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: '0px 2px 2px #00000014',
        }}
      >
        <Stack justifyContent="center" alignItems="center">
          <Typography
            sx={{
              mt: '56px',
              font: 'normal normal bold 32px/48px BIZ UDGothic',
              textAlign: 'center',
            }}
          >
            {translation['button_delete']}
          </Typography>
          <Typography
            sx={{
              mt: '48px',
              mr: '50px',
              ml: '50px',
              color: '#282828',
              font: 'normal normal normal 21px/32px Noto Sans JP',
              textAlign: 'center',
            }}
          >
            {text ? (
              <>
                {`${translation['confirmation_delete_priority_word']}`
                  .replace('ZZ', title || '')
                  .replace('XXXXX', truncate(text || ''))}
              </>
            ) : (
              <>{translation['confirmation_delete']}</>
            )}
          </Typography>

          <DialogActions sx={{ mt: '48px' }}>
            <Button
              onClick={onClose}
              sx={{
                height: '49px',
                width: '181px',
                font: 'normal normal bold 21px/29px Noto Sans JP',
                color: '#282828',
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                border: '2px solid #282828',
                borderRadius: '10px',
                mr: '40px',
                '&:hover': {
                  background: '#FFFFFF',
                  opacity: 0.8,
                },
              }}
            >
              {translation['button_cancel']}
            </Button>
            <Button
              type="submit"
              onClick={handleDel}
              sx={{
                height: '49px',
                width: '181px',
                font: 'normal normal bold 21px/29px Noto Sans JP',
                color: '#FFFFFF',
                background: 'red',
                '&:hover': {
                  background: 'red',
                  opacity: 0.7,
                  boxShadow: 0,
                },
                borderRadius: '10px',
              }}
            >
              {translation['button_delete']}
            </Button>
          </DialogActions>
        </Stack>
      </Box>
    </Modal>
  )
}
